module.exports = __webpack_public_path__ + "static/process-inset-photo-fc25bb4d10701d6f4546668e90fc62c6.jpg";